import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import PageStructure from 'flarum/forum/components/PageStructure';
import IndexPage from 'flarum/forum/components/IndexPage';
import Link from 'flarum/common/components/Link';
function members() {
  const data = app.data.xgayThanksVip;
  if (!Array.isArray(data)) return [];
  return data.filter(item => {
    if (typeof item !== 'object' || item === null) return false;
    const value = item;
    return Number.isInteger(value.id) && Number(value.id) > 0 && typeof value.name === 'string' && typeof value.slug === 'string' && value.slug.length > 0;
  });
}
function cloud(placement) {
  const users = members();
  if (!users.length) return null;
  return m("section", {
    className: 'ThanksVip ThanksVip--' + placement,
    "aria-label": String(app.translator.trans('xgay-thanks-vip.forum.title'))
  }, m("h3", {
    className: "ThanksVip-title"
  }, app.translator.trans('xgay-thanks-vip.forum.title')), m("ul", {
    className: "ThanksVip-cloud"
  }, users.map(user => m("li", {
    key: user.id,
    className: 'ThanksVip-name ThanksVip-size' + user.id % 3
  }, m(Link, {
    href: app.route('user', {
      username: user.slug
    })
  }, user.name)))));
}
app.initializers.add('xgay-thanks-vip', () => {
  extend(PageStructure.prototype, 'sidebarItems', function (items) {
    if (app.current.matches(IndexPage)) items.add('xgay-thanks-vip', cloud('desktop'), -100);
  });
  extend(IndexPage.prototype, 'contentItems', function (items) {
    items.add('xgay-thanks-vip', cloud('mobile'), items.getPriority('discussionList') - 1);
  });
});